import type { IconGlyph } from '../icon';

import { iconPlusThick } from './plus-thick';

/**
 * Tractie `plus` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/plus.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconPlus: IconGlyph = {
  name: 'plus',
  path: 'M19.5 11.5h-7v-7c0-.28-.22-.5-.5-.5s-.5.22-.5.5v7h-7c-.28 0-.5.22-.5.5s.22.5.5.5h7v7c0 .28.22.5.5.5s.5-.22.5-.5v-7h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5',
  selected: iconPlusThick,
};
